// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Traffic Config API
 * traffic-config-api manages traffic configuration for the Aura platform.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CidrBlock } from './CidrBlock';
import {
  CidrBlockFromJSON,
  CidrBlockFromJSONTyped,
  CidrBlockToJSON,
  CidrBlockToJSONTyped,
} from './CidrBlock';

/**
 *
 * @export
 * @interface IpfilterIngressFilter
 */
export interface IpfilterIngressFilter {
  /**
   *
   * @type {Array<CidrBlock>}
   * @memberof IpfilterIngressFilter
   */
  allowList?: Array<CidrBlock>;
  /**
   *
   * @type {boolean}
   * @memberof IpfilterIngressFilter
   */
  brainIpAddressesEnabled?: boolean;
  /**
   *
   * @type {string}
   * @memberof IpfilterIngressFilter
   */
  dbid?: string;
  /**
   *
   * @type {boolean}
   * @memberof IpfilterIngressFilter
   */
  filteringDisabled?: boolean;
  /**
   *
   * @type {string}
   * @memberof IpfilterIngressFilter
   */
  status?: string;
  /**
   *
   * @type {string}
   * @memberof IpfilterIngressFilter
   */
  tenantId?: string;
}

/**
 * Check if a given object implements the IpfilterIngressFilter interface.
 */
export function instanceOfIpfilterIngressFilter(
  value: object,
): value is IpfilterIngressFilter {
  return true;
}

export function IpfilterIngressFilterFromJSON(
  json: any,
): IpfilterIngressFilter {
  return IpfilterIngressFilterFromJSONTyped(json, false);
}

export function IpfilterIngressFilterFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): IpfilterIngressFilter {
  if (json == null) {
    return json;
  }
  return {
    allowList:
      json['allowList'] == null
        ? undefined
        : (json['allowList'] as Array<any>).map(CidrBlockFromJSON),
    brainIpAddressesEnabled:
      json['brainIpAddressesEnabled'] == null
        ? undefined
        : json['brainIpAddressesEnabled'],
    dbid: json['dbid'] == null ? undefined : json['dbid'],
    filteringDisabled:
      json['filteringDisabled'] == null ? undefined : json['filteringDisabled'],
    status: json['status'] == null ? undefined : json['status'],
    tenantId: json['tenantId'] == null ? undefined : json['tenantId'],
  };
}

export function IpfilterIngressFilterToJSON(json: any): IpfilterIngressFilter {
  return IpfilterIngressFilterToJSONTyped(json, false);
}

export function IpfilterIngressFilterToJSONTyped(
  value?: IpfilterIngressFilter | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    allowList:
      value['allowList'] == null
        ? undefined
        : (value['allowList'] as Array<any>).map(CidrBlockToJSON),
    brainIpAddressesEnabled: value['brainIpAddressesEnabled'],
    dbid: value['dbid'],
    filteringDisabled: value['filteringDisabled'],
    status: value['status'],
    tenantId: value['tenantId'],
  };
}
